import cn from 'classnames';
import styles from './UserCard.module.css';
import { FunctionComponent, useMemo } from 'react';
import {Image} from 'react-bootstrap';

export interface IUserCardProps {
  userName: string;
  userHandle?: string;
  userImage: string | null;
  className?: string;
}

export const getColorForUser = (key: string) => {
  
  const colors = [
    '#FF5733', '#33FF57', '#3357FF', '#FF33A8', '#FF8C33',
    '#33FFF5', '#9D33FF', '#FFD733', '#33FFB8', '#FF3333'
  ];

  const normalizedKey = key.toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalizedKey?.length; i++) {
    hash = normalizedKey.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

const UserCard: FunctionComponent<IUserCardProps> = ({userName, userHandle, userImage, className}) => {
  const bgColor = useMemo(
    () => getColorForUser(userName),
    [userName]
  );

  return (
    <div className={cn(styles.userCard, className)}>
        <div className={cn(styles.userAvatar, !userImage && styles.userAvatarText)}
        style={!userImage ? { backgroundColor: bgColor } : undefined}
        >
            {userImage ? 
                <Image src={userImage} alt={userName} /> : 
                (userName ? userName.trim()?.charAt(0).toUpperCase() : '?')
            }
        </div>
        <div className={styles.userName}>
            <div className={styles.userNameText}>{userName}</div>
            {userHandle && <div className={styles.userHandle}>@{userHandle}</div>}
        </div>
    </div>
  );
};

export default UserCard;
